// =====================================================================
// CÓMO LE LLEGA SU CUENTA · CORREO Fase 2 (carril accesos)
// =====================================================================
// Se monta dentro del diálogo «Invitación lista» (Usuarios.jsx), con los
// datos que la pantalla todavía tiene en memoria: el código y el enlace
// se ven una sola vez y no viven en la base. Tres caminos, sin fingir:
// la hoja impresa siempre; el correo solo si este servidor manda correo
// (si no, se dice y el correo queda guardado para reenviar); y «se lo
// dicté» para dejar constancia del cuarto camino.
import { useState } from 'react';
import { api } from '../api';
import { guardarArchivo } from '../ui/descarga';

export default function EntregaDeInvitacion({ datos }) {
  const [correo, setCorreo] = useState('');
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);
  const [ocupado, setOcupado] = useState(false);
  if (!datos?.id || !datos?.codigo) return null;

  const persona = {
    id: datos.id,
    nombre_completo: datos.nombre_completo || '',
    nombre_usuario: datos.nombre_usuario || null,
    telefono: datos.telefono || null,
    codigo: datos.codigo,
    enlace: datos.enlace_directo || datos.enlace,
    expira_en: datos.expira_en,
  };

  async function hoja() {
    setErr(null); setMsg(null); setOcupado(true);
    try {
      const blob = await api.descargar('/accesos/invitaciones/hoja.pdf', { personas: [persona] });
      guardarArchivo(blob, `hoja-de-bienvenida-${persona.nombre_usuario || persona.id}.pdf`);
      setMsg('Hoja lista para imprimir. Entrégala en mano y guarda la copia firmada.');
    } catch (e) { setErr(e.message || 'No se pudo generar la hoja.'); }
    finally { setOcupado(false); }
  }

  async function mandar() {
    setErr(null); setMsg(null); setOcupado(true);
    try {
      const r = await api.post(`/accesos/invitaciones/${persona.id}/correo`, {
        correo: correo.trim(), codigo: persona.codigo, enlace_directo: persona.enlace,
      });
      setMsg(r.mensaje);
    } catch (e) { setErr(e.message || 'No se pudo mandar el correo.'); }
    finally { setOcupado(false); }
  }

  async function dictada() {
    setErr(null); setMsg(null);
    try {
      await api.post(`/accesos/invitaciones/${persona.id}/entregada`, { por: 'PANTALLA' });
      setMsg('Anotado: se le dictó en persona.');
    } catch (e) { setErr(e.message); }
  }

  return (
    <div className="text-left border-t border-gray-100 pt-3 space-y-2">
      <p className="text-sm font-medium text-gray-800">¿Cómo se la entregas?</p>
      <div className="flex flex-wrap gap-2">
        <button type="button" onClick={hoja} disabled={ocupado}
                className="px-3 py-2 text-sm rounded-lg bg-[var(--color-marca)] text-white font-semibold disabled:opacity-50">
          Imprimir hoja de bienvenida
        </button>
        <button type="button" onClick={dictada} disabled={ocupado}
                className="px-3 py-2 text-sm rounded-lg border border-gray-200">
          Se la dicté en persona
        </button>
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        <input value={correo} onChange={(e) => setCorreo(e.target.value)} type="email" placeholder="correo@ejemplo.com"
               aria-label="Correo al que mandarla" className="border border-gray-300 rounded-lg px-2 py-2 text-sm flex-1 min-w-[12rem]" />
        <button type="button" onClick={mandar} disabled={ocupado || !correo.includes('@')}
                className="px-3 py-2 text-sm rounded-lg border border-gray-200 disabled:opacity-50">
          Mandar por correo
        </button>
      </div>
      <p className="text-xs text-gray-500">
        La hoja lleva el QR de un solo uso, el código de respaldo, hasta cuándo sirven, el aviso de privacidad corto
        y dos líneas de firma. El correo solo sale si este servidor manda correo; si no, se dice y queda guardado.
      </p>
      {msg && <p role="status" className="text-sm text-green-800 bg-green-50 border border-green-200 rounded-lg p-2.5">{msg}</p>}
      {err && <p role="alert" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-2.5">{err}</p>}
    </div>
  );
}
